// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Vj8ls","inputField":"styles_inputField__VX1F4","labelClassName":"styles_labelClassName__aF-id"};